"use strict";var global=require("./_global"),navigator=global.navigator;module.exports=navigator&&navigator.userAgent||"";